module.exports = __webpack_public_path__ + "static/media/platformFeatures1.c60d0b4f.png";